module.exports = __webpack_public_path__ + "static/media/play_icon.bb4d2cc2.png";